import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import "./assets/css/custom.css"
import { HashRouter } from "react-router-dom";
import AppRoute from "./AllRoutes/AppRoute";
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import "react-datepicker/dist/react-datepicker.css";

function App(props) {
    return (
        <>
            <HashRouter>
                <AppRoute />
            </HashRouter>
        </>
    );
}

export default App;